// Copyright (c) Bentley Systems
import * as React from "react";
import { SVGProps, useEffect, useState } from "react";
import { animated, useSprings } from "@react-spring/web";
import { AnimatedIconProps } from "./AnimatedIconProps";

const BottomRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#67b01a"
        fillOpacity="60%"
        stroke="#fff"
        strokeOpacity="0.6"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(5 5)"
       />
      <path
        transform="translate(5)"
        fill="#fff"
        d="M30 15h-.8c-.3 0-.6.3-.6.6v3.8c0 .3.3.6.6.6h.8c.8 0 1.4-.6 1.4-1.4v-2.2c0-.8-.6-1.4-1.4-1.4z"
       />
      <path
        transform="translate(5)"
        fill="#fff"
        d="M10 33c0-.3-.3-.6-.6-.6H7.8c-.3 0-.6.3-.6.6s.3.6.6.6h1.6c.3 0 .6-.3.6-.6zm-2.2-14h1.6c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H7.8c-.3 0-.6.3-.6.6s.3.6.6.6zm0 7h1.6c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H7.8c-.3 0-.6.3-.6.6s.3.6.6.6z"
       />
      <path
        transform="translate(5)"
        fill="#fff"
        d="M30.8 22h-.6v6h.6c.3 0 .6-.4.6-.8v-4.4c0-.5-.3-.8-.6-.8zm0 8h-.6v6h.6c.3 0 .6-.4.6-.8v-4.4c0-.5-.3-.8-.6-.8z"
       />
      <path
        transform="translate(5)"
        fill="#fff"
        d="M27 22c-.3 0-.6-.3-.6-.6V15c0-.3-.3-.6-.6-.6H10c-.3 0-.6.3-.6.6v1.4c0 .3.3.6.6.6h1.4c.3 0 .6.3.6.6v3c0 .3-.3.6-.6.6H10c-.3 0-.6.3-.6.6s.3.6.6.6h1.4c.3 0 .6.3.6.6v3c0 .3-.3.6-.6.6H10c-.3 0-.6.3-.6.6s.3.6.6.6h1.4c.3 0 .6.3.6.6v3c0 .3-.3.6-.6.6H10c-.3 0-.6.3-.6.6v1.4c0 .3.3.6.6.6h16c.3 0 .6-.3.6-.6V22.6c0-.3-.3-.6-.6-.6z"
       />
      <circle
        cx="28.5"
        cy="32"
        r="4"
        fill="#0E630A"
        stroke="#fff"
        strokeWidth="0.7"
       />
      <path
        d="M26.7 32l1 1 2-2.4"
        stroke="#fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
       />
    </g>
  );
}

const TopRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#87cd1e"
        stroke="#83c444"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(0)"
       />
    </g>
  );
}

const SubscribedProjectsAnim = (props: AnimatedIconProps) => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    if (props.isFocused !== undefined) {
      setToggle(props.isFocused);
    }
  }, [props.isFocused]);

  const rectangles = [
    <TopRectangle key="rectangle1" />,
    <BottomRectangle key="rectangle2" />,
  ];

  const springs = useSprings(
    rectangles.length,
    rectangles.map((el, index) => {
      return {
        transform: toggle
          ? `translate3d(0px, 0px, 0px)`
          : `translate3d(${index === 1 ? -5 : 5}px, 0px, 0px)`,
      };
    })
  );

  const animatedRectangles = springs.map((animatedStyle, index) => (
    <animated.g key={index} style={animatedStyle}>
      {rectangles[index]}
    </animated.g>
  ));

  return (
    <div
      onMouseOver={() => {
        if (props.isFocused === undefined) {
          setToggle(true);
        }
      }}
      onMouseOut={() => {
        if (props.isFocused === undefined) {
          setToggle(false);
        }
      }}
    >
      <svg
        style={{ height: "100%", width: "100%" }}
        xmlns="http://www.w3.org/2000/svg"
        width="47"
        height="47"
        viewBox="0 0 47 47"
      >
        {animatedRectangles}
      </svg>
    </div>
  );
};

export default SubscribedProjectsAnim;
